import { rtdb, server_value } from "@/firebase";

export async function listenToUserOnlineStatus({bot_id, conversation_id}){

  var myConnectionsRef = rtdb.ref(`connections/${bot_id}/${conversation_id}/online`);

  var lastOnlineRef = rtdb.ref(`connections/${bot_id}/${conversation_id}/last_online`);

  var connectedRef = rtdb.ref('.info/connected');
  connectedRef.on('value', function(snap) {
    if (snap.val() === true) {
      myConnectionsRef.set(true);

      myConnectionsRef.onDisconnect().set(false);

      lastOnlineRef.onDisconnect().set(server_value.TIMESTAMP);
    }
  });
}

export async function subscribeToState({processChatState, bot_id, conversation_id}){
  const ref = rtdb.ref(`states/${bot_id}/${conversation_id}/state`);
  ref.on('value', (snapshot) => {
    processChatState(snapshot.val());
  });
}

export async function subscribeToMessages({processChatMessage, bot_id, conversation_id }){
  const ref = await rtdb.ref(`conversations/${bot_id}/${conversation_id}/messages`);
  ref.on('child_added', (snapshot) => {
    if(snapshot.val()){
      processChatMessage({message_data: snapshot.val()});
    }
  });
}

export async function subscribeToLock({processLockStatus, bot_id, conversation_id }){
  await rtdb.ref(`locks/${bot_id}/${conversation_id}/locked`)
  .on('value', 
    (snapshot) => {
      if(snapshot.val() != null){
        processLockStatus({current_lock: snapshot.val()});
      }
    });
}

export async function subscribeToLoad({processLoadStatus, bot_id, conversation_id }){
  await rtdb.ref(`details/${bot_id}/${conversation_id}/loading`)
  .on('value', 
    (snapshot) => {
      if(snapshot.val() != null){
        processLoadStatus({loading: snapshot.val()});
      }
    });
}